var render = function () {
var _obj;
var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('FormInputContainer',{staticClass:"FormNumber",attrs:{"inputId":("I" + _vm._uid),"label":_vm.label,"sublabel":_vm.sublabel,"errors":_vm.errors}},[_c('input',_vm._g(_vm._b({attrs:{"id":("I" + _vm._uid),"type":"number","step":_vm.step},domProps:{"value":_vm.value}},'input',_vm.$attrs,false),( _obj = {}, _obj[_vm.lazy ? 'change' : 'input'] = _vm.handleInput, _obj )))])}
var staticRenderFns = []

export { render, staticRenderFns }